import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import axios from "axios";
export var name = 'api';
export var namespaced = true;

var Client = /*#__PURE__*/function () {
  function Client(axios) {
    _classCallCheck(this, Client);

    this.deserialize = false;
    this.axios = axios;
  }

  _createClass(Client, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action, config) {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.get(action, this.getConfig(config));

              case 2:
                response = _context.sent;

                if (!this.deserialize) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", this.deserializeData(response));

              case 5:
                return _context.abrupt("return", response);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "typedGet",
    value: function () {
      var _typedGet = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(action, config) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.axios.get(action, this.getConfig(config));

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function typedGet(_x3, _x4) {
        return _typedGet.apply(this, arguments);
      }

      return typedGet;
    }()
  }, {
    key: "post",
    value: function post(action, data, config) {
      return this.axios.post(action, data, this.getConfig(config));
    }
  }, {
    key: "typedPost",
    value: function typedPost(action, data, config) {
      return this.axios.post(action, data, this.getConfig(config));
    }
  }, {
    key: "put",
    value: function put(action, data, config) {
      return this.axios.put(action, data, this.getConfig(config));
    }
  }, {
    key: "patch",
    value: function patch(action, data, config) {
      return this.axios.patch(action, data, this.getConfig(config));
    }
  }, {
    key: "delete",
    value: function _delete(action, config) {
      return this.axios.delete(action, this.getConfig(config));
    }
  }, {
    key: "deserializeData",
    value: function deserializeData(response) {
      var isEmptyArray = Array.isArray(response.data) && response.data.length == 0;

      if (isEmptyArray || !response.data) {
        return response.data;
      }

      var JSONAPIDeserializer = require('ts-jsonapi').Deserializer;

      return new JSONAPIDeserializer({
        keyForAttribute: 'camelCase'
      }).deserialize(response.data);
    }
  }, {
    key: "getConfig",
    value: function getConfig(config) {
      var authCookie = this.getCookie('auth._token.local');
      var authConfig = {
        headers: {
          'Authorization': authCookie
        }
      };
      var mergedConfig = Object.assign({}, config, authConfig);
      return mergedConfig;
    }
  }, {
    key: "getCookie",
    value: function getCookie(name) {
      var nameLenPlus = name.length + 1;
      return document.cookie.split(';').map(function (c) {
        return c.trim();
      }).filter(function (cookie) {
        return cookie.substring(0, nameLenPlus) === "".concat(name, "=");
      }).map(function (cookie) {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || "";
    }
  }]);

  return Client;
}();

var ClientFactory = /*#__PURE__*/function () {
  function ClientFactory() {
    _classCallCheck(this, ClientFactory);
  }

  _createClass(ClientFactory, null, [{
    key: "createApiClient",
    value: function createApiClient() {
      var axiosInstance = axios.create({
        baseURL: process.env.apiBaseUrl
      });
      return new Client(axiosInstance);
    }
  }]);

  return ClientFactory;
}();

export { Client, ClientFactory };